import { render, staticRenderFns } from "./CustomerMessageDashboard.vue?vue&type=template&id=050300b1&scoped=true"
import script from "./CustomerMessageDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerMessageDashboard.vue?vue&type=script&lang=js"
import style0 from "./CustomerMessageDashboard.vue?vue&type=style&index=0&id=050300b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050300b1",
  null
  
)

export default component.exports